import { request } from '../lib/http'

/**
 * @returns {Promise<Array>}
 */
export function fetchAll () {
  return request({
    url: 'statusostests',
    method: 'get'
  })
}
